// The enrollment editor reuses the FULL base node definitions (the hydra editor
// needs the complete map — e.g. `message:*`, `task:*`, if-branch internals — or
// it fails to initialize). We only RESTRICT the palette (see
// default-enrollment-items-config.js) and add a deletion guard to the data nodes.
//
// NOTE: we intentionally do NOT add editable `alias` / `saveToProfile` fields to
// the node-info panel. `alias` is assigned/managed on the backend (it is a
// stable key many parts of the code rely on — e.g. cohort) and must not be
// editable here; `saveToProfile` has separate logic handled elsewhere. The
// backend-set `data.alias` is preserved by the editor regardless (it just isn't
// shown as an editable field).

// Data-collection node types in the enrollment palette.
export const ENROLLMENT_DATA_NODE_TYPES = [
  "message:input",
  "message:single",
  "message:multi",
  "message:date",
  "message:time",
];

// Mutate a full (already deep-cloned) node-definitions map in place, attaching a
// deletion guard to the data nodes. Returns the same object.
export function augmentEnrollmentDefinitions(defs) {
  if (!defs) {
    return defs;
  }

  for (const nodeType of ENROLLMENT_DATA_NODE_TYPES) {
    const def = defs[nodeType];
    if (!def) {
      continue;
    }

    // Block deletion of the mandatory reserved-alias nodes (email / cohort).
    // The editor's useAllowDeletion hook calls fetchProfileManagement(nodeProps)
    // and disallows deletion when the node's `id` is returned by it; our fetcher
    // (see enrollment-scenario.jsx) returns the node id only for protected
    // aliases, so author-added nodes stay freely deletable.
    def.deletionPredicate = {
      fromFetchContext: true,
      predicate: "notIncludes",
      fetchContextFunction: "fetchProfileManagement",
      key: "id",
      valuePath: "id",
      violationMessage: "This node is required for the invitation and can’t be deleted.",
    };
  }

  return defs;
}
